import apiClient from './axios';
import type { ApiResponse } from '@shared/types/api.types';

export interface UpdateOnboardingRequest {
  step?: number;
  fitnessGoal?: string;
  initialGrade?: string;
}

export interface OnboardingResponse {
  id: string;
  onboardingStep: number;
  fitnessGoal: string | null;
  initialGrade: string | null;
}

export interface UpdateProfileRequest {
  nickname?: string;
  gender?: 'male' | 'female';
  height?: number;
  weight?: number;
  birthdate?: string; // YYYY-MM-DD
  profileImageUrl?: string;
}

export interface ProfileResponse {
  id: string;
  email: string;
  nickname: string | null;
  gender: string | null;
  height: number | null;
  weight: number | null;
  birthdate: string | null;
  profileImageUrl: string | null;
  updatedAt: string;
}

/**
 * 온보딩 단계 업데이트
 */
export async function updateOnboarding(data: UpdateOnboardingRequest): Promise<OnboardingResponse> {
  const response = await apiClient.patch<ApiResponse<OnboardingResponse>>('/users/me/onboarding', data);
  return response.data.data!;
}

/**
 * 프로필 업데이트
 */
export async function updateProfile(data: UpdateProfileRequest): Promise<ProfileResponse> {
  const response = await apiClient.patch<ApiResponse<ProfileResponse>>('/users/me', data);
  return response.data.data!;
}
